import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import * as Styled from "./Modal.styled";
import { useScrollLock } from "../../../components/hooks";


interface IModalProps {
    show?: boolean;
    onHide?: () => void;
    header?: React.ReactNode;
    body?: React.ReactNode;
    children?: React.ReactNode;
    zIndex?: number;
}

interface Props {
    children: React.ReactNode;
}

export const DefaultModalHeader: React.FC = () => (
    <Styled.ModalHeaderWrapper data-cemboo="modal-header">
        <Styled.ModalTitleText data-cemboo="modal-title">Modal Title</Styled.ModalTitleText>
        <Styled.CloseButton data-cemboo="modal-close" aria-label="Close">
            X
        </Styled.CloseButton>
    </Styled.ModalHeaderWrapper>
);

export const ModalHeader: React.FC<Props> = ({ children }) => (
    <Styled.ModalHeaderWrapper data-cemboo="modal-header">
        <Styled.ModalTitleText data-cemboo="modal-title">{children}</Styled.ModalTitleText>
        <Styled.CloseButton data-cemboo="modal-close" aria-label="Close">
            X
        </Styled.CloseButton>
    </Styled.ModalHeaderWrapper>
);

export const FullScreenModal: React.FC<IModalProps> = ({
    show = false,
    onHide,
    header,
    body,
    children,
    zIndex,
}) => {
    const onHideHandler = React.useCallback(() => {
        onHide?.();
    }, [onHide]);

    useScrollLock(show);

    const zStyle = zIndex
        ? ({ "--cemboo-modal-z": zIndex } as React.CSSProperties)
        : undefined;

    return (
        <Dialog.Root open={show} onOpenChange={(open: boolean) => !open && onHideHandler()} modal={false}>
            <Dialog.Portal>
                <Styled.DialogOverlay data-cemboo="modal-overlay" style={zStyle} />
                <Styled.DialogContent className="cemboo-dialog" data-cemboo="modal-content" style={zStyle} onInteractOutside={(e) => e.preventDefault()}>
                    {header ?? <></>}
                    <Styled.ModalBodyWrapper data-cemboo="modal-body">
                        {body ?? children}
                    </Styled.ModalBodyWrapper>
                </Styled.DialogContent>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
